import { render, staticRenderFns } from "./ClaimParticulars.vue?vue&type=template&id=0e82e34c"
import script from "./ClaimParticulars.vue?vue&type=script&lang=js"
export * from "./ClaimParticulars.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports